<!-- 销售退补价申请 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="400px">
            <rateSalesReimburAction v-if="showStatus" ref="rateSalesReimburAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></rateSalesReimburAction>
        </el-drawer>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch"></v-search>
            </div>
        </div>
        <div class="page_content_center">
            <el-table size="mini" v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" @selection-change="handleSelectionChange" highlight-current-row>
                <el-table-column type="selection" width="40"></el-table-column>
                <el-table-column align="center" v-if="tableValye.isShow==1" v-for="(tableValye,tableKey) in pageShowData.jurTableVo.jurconfigtable" show-overflow-tooltip :min-width="tableValye.fieldWeight" :key="tableKey"
                    :prop="tableValye.entityField" :label="tableValye.showField">
                    <template slot-scope="scope">
                        <span v-if="tableValye.fieldType == 'date'">
                            <span v-if="scope.row[tableValye.entityField]">
                                {{$common.getLocalTime(scope.row[tableValye.entityField])}}
                            </span>
                        </span>
                        <span v-else-if="tableValye.isRift == 1">
                            <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
                        </span>
                        <span v-else-if="tableValye.entityField == 'isWms'">
                            <span v-for="(item,index) in JSON.parse(tableValye.formatterContent)" :key="index">
                                <el-tag size="mini" v-if="item.key == scope.row.isWms">{{item.value}}</el-tag>
                            </span>
                        </span>
                        <span v-else-if="tableValye.entityField == 'rramState'">
                            <span v-for="(item,index) in JSON.parse(tableValye.formatterContent)" :key="index">
                                <el-tag size="mini" v-if="item.key == scope.row.rramState">{{item.value}}</el-tag>
                            </span>
                        </span>
                        <span v-else-if="tableValye.entityField == 'createTime'">
                            <span v-if="scope.row[tableValye.entityField]">
                                {{$common.getLocalTime(scope.row[tableValye.entityField])}}
                            </span>
                        </span>
                        <span v-else>
                            {{scope.row[tableValye.entityField]}}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :smId="smId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
        <orderKeepPrint ref="orderKeepPrint"></orderKeepPrint>

    </div>
</template>
  
  <script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue";
import rateSalesReimburAction from "@/components/rateSalesReimburAction.vue";
import orderKeepPrint from "@/components/orderKeepPrint.vue";
import NP from "number-precision";

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        rateSalesReimburAction,
        orderKeepPrint
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {
                rramRetcus: "",
                cmName: '',
                page: 1,
                rows: 30,
                start: '',	//开始上一个月
                end: '',	//当天最后时间
                cmId: '',
                cmName: ''
            },
            returnData: {
                pages: 0,  // 总页数
                total: 0,  // 总条数
                pageNum: 0,  // 当前页数
                list: []
            },
            buttonList: [],
            pageShowData: [],
            formDataList: [],
            exId: "",
            seId: "",
            ceshi: "",
            dialogTitle: "",
            seWidth: "",
            height: "",
            exTitle: "",
            seTitle: "",
            seWidth: "",
            exWidth: "",
            DialogVisible: false,
            DialogExtract: false,
            seType: '',
            smId: '',
            showStatus: false,
            actionData: {},
            parentSearchData: {},
            sField: '',
            multipleSelection: [],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        'getRequestData.cmName': {
            handler: function (newValue, oldValue) {
                if (newValue == '') {
                    this.getRequestData.rramRetcus = ''
                }
            },
            deep: true,
        }
    },
    //方法集合
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 子组件触发
        drawerCancel(val) {
            this.showStatus = false
            this.getDataList()
            if (val!=0) {
                this.$refs.orderKeepPrint.openBox(val, "比例销售退补")
            }
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({  //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: { isPenetrate } //参数
                }, '*');
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        getExtractName(e) {
            this.exTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch({ sId, index, type, sField }) {
            this.DialogVisible = true
            this.seId = sId
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
        },
        isShowData(name, value) {
            switch (name) {
                case 'customerList':
                    var dataInfo = sessionStorage.getItem('selectCustomerData')
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo)
                        this.getRequestData.rramRetcus = dataInfo.cmId
                        this.getRequestData.cmName = dataInfo.cmName
                    }

                    break;

                default:
                    this.getRequestData[name] = value

            }
        },



        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path)
            let responseData = await this.$http.getJur({ ids: [pathId.jurId] })
            if (responseData.status == 200) {
                this.getButtonList()
                this.pageShowData = responseData.result
                this.formDataList = this.pageShowData.jurFormVoList
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:
                    if (this.returnData.list.length <= 0) {
                        if (!dataInfo) {
                            this.$message({
                                message: '暂无数据',
                                type: 'error'
                            });
                            return false
                        }
                    }
                    if (this.multipleSelection.length == 0) {
                        this.$message({
                            message: "请先选中操作数据",
                            type: "error",
                        });
                        return false;
                    }
                    if (this.multipleSelection.filter(item => item.cmId != this.multipleSelection[0].cmId).length > 0) {
                        return this.$message.error("请勾选相同单位的数据！")
                    }
                    var totalMoney = 0
                    this.multipleSelection.forEach(item => {
                        totalMoney = this.$common.getDecimalInfo(3, NP.plus(Number(totalMoney) + Number(item.totalMoney)))
                    })

                    this.showStatus = true;
                    this.actionData = {
                        cate: 1,
                        formData: this.formDataList,
                        oldData: {
                            totalMoney: totalMoney,
                            wobkemIds: this.multipleSelection.map(item => item.wobkemId)
                        },
                        orderId: this.multipleSelection[0].rramId,
                        printSouce: '',
                        printJurId: ''
                    }
                    break;
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },
        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },
        // 获取数据列表
        async getDataList() {
            if (this.getRequestData.cmName == '') {
                this.getRequestData.cmId = ''
            }
            let responseData = await this.$http.wobkequeryWobkList(this.getRequestData)
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list
                console.log(this.returnData.list)
                this.returnData.pages = responseData.result.pages
                this.returnData.total = responseData.result.total
                this.returnData.pageNum = responseData.result.pageNum
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
        initTime() {
            this.getRequestData.start = this.$common.getStartTime()
            this.getRequestData.end = this.$common.getEndTime()
        },



    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo()
        this.initTime()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
  </script>
  <style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
</style>